<template>
  <div>
    <el-drawer
        size="80%"
        custom-class="custom-drawer"
        title="关联达人列表"
        :visible.sync="visible">
      <div style="padding: 20px">
        <div class="forms-container">
          <el-form :model="searchForm" class="search-form" ref="searchFormRef">
            <el-form-item label="" prop="searchContent">
              <el-input
                  style="width:300px"
                  :maxlength="100"
                  v-model="searchForm.searchContent"
                  placeholder="达人昵称/抖音ID"
              />
            </el-form-item>
            <el-form-item>
              <el-date-picker
                  v-model="searchForm.timeArr"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="daterange"
                  range-separator="-"
                  start-placeholder="绑定开始日期"
                  end-placeholder="绑定结束日期"
                  :default-time="['00:00:00', '23:59:59']"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <!-- 操作按钮 -->
              <el-button type="warning" @click="onFormSearch">查询</el-button>
              <el-button type="warning" plain @click="onFormReset">重置</el-button>
              <el-button type="primary" @click="onExport" :disabled="exportLoading" :loading="exportLoading">导出</el-button>
            </el-form-item>
          </el-form>
        </div>
        <el-table :data="tableList.list" v-loading="loading" highlight-current-row border style="width: 100%">
          <el-table-column prop="fansId" label="用户ID" width="300"/>
          <el-table-column prop="nickname" label="抖音昵称" />
          <el-table-column prop="douyinid" label="抖音ID" />
          <el-table-column prop="phone" label="注册手机号" >
            <template slot-scope="scope">
              {{ scope.row.phone || '--' }}
            </template>
          </el-table-column>
          <el-table-column prop="distributeGoodsNum" label="推广商品数" />
          <el-table-column prop="darenCommissionBd" label="达人佣金" />
          <el-table-column prop="registerTime" label="注册时间" width="180" />
          <el-table-column prop="bindStatusStr" label="绑定状态" width="180" />
          <el-table-column prop="bindTime" label="绑定时间" width="180" />
        </el-table>
        <el-pagination
            v-if="tableList.total > 0"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableList.currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="tableList.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableList.total"
        >
        </el-pagination>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import poi from "@/api/poi";
import {goExportCenter} from "../../../../../utils/tool";
const PoiModel = new poi();
export default {
  data() {
    return {
      searchForm: {
        searchContent: '',
        timeArr: null
      },
      openParams:{},
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      loading: false,
      tableList:{
        pageSize: 10,
        currentPage: 1,
        total: 0,
        list:[],
      },
      visible: false,
      exportLoading: false
    }
  },
  methods:{
    open(params){
      this.openParams = params;
      this.visible = true;
      this.getList()
    },
    getParams(){
      const params = {
        ...this.searchForm
      }
      params.bindStartTime = this.searchForm.timeArr ? this.searchForm.timeArr[0] : '';
      params.bindEndTime = this.searchForm.timeArr ? this.searchForm.timeArr[1] : '';
      delete params.timeArr
      return {
        ...this.openParams,
        ...params
      }
    },
    async getList() {
      this.loading = true
      const res = await PoiModel.getDarenList({
        ...this.getParams(),
        pageNo: this.params.pageNo,
        pageSize: this.params.pageSize,
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.tableList.list = res.data.data.list || [];
      this.tableList.total = res.data.data.total || 0;
      this.loading = false;
      this.tableList.currentPage = res.data.data.pageNo;
      this.tableList.pageSize = res.data.data.pageSize;
    },
    // 表单搜素
    onFormSearch() {
      debounce(
          () => {
            this.$refs['searchFormRef'].validate((valid) => {
              if (valid) {
                this.params.pageNo = 1;
                this.getList();
              } else {
                return false;
              }
            });
          },
          500,
          true
      );
    },
    reset() {
      this.searchForm = {
        searchContent: '',
        timeArr: null
      }
      this.params.pageNo = 1;
      this.params.pageSize = 10;
      this.$refs['searchFormRef'].resetFields();
    },
    onFormReset() {
      debounce(() => {
        this.reset()
        this.getList()
      }, 1000, true)
    },
    handleSizeChange(val) {
      this.params.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getList();
    },
    async onExport(){
      const params = this.getParams();
      if(!params.bindStartTime || !params.bindEndTime){
        this.$message.error('请选择日期')
        return;
      }

      this.exportLoading = true;
      const res = await PoiModel.exportMyDarenListExport({
        ...params,
      }).finally(()=>{
        this.exportLoading = false;
      });
      if(!res.data.success) {
        this.$message.error(res.data.message);
        return;
      }
      this.exportLoading = false;

      await goExportCenter()
    }
  },
};
</script>

<style>
.pagination {
  margin-top: 20px;
  text-align: right;
}
.custom-drawer{
  overflow-y: scroll !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/components/popDarenNum.vue